import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Notification = ({ notificationData, setNotification }) => {
    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    const handleClick = () => {
        setNotification('', '')
    }

    return (
        <section id="js-notifications-group" className="c-notifications-group  js-panelgroup">
            <div className="c-notification__container  js-notification-container">
                <div className={`c-notification  c-notification--${notificationData.notificationType}`}>
                    <div className="c-notification__outer-wrap">
                        <div className="c-notification__inner-wrap">
                            <i className="c-notification__status-icon"></i>
                            <p className="c-notification__text">{notificationData.message}</p>
                            <button className="c-notification__close" onClick={() => handleClick()}></button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

Notification.propTypes = {
    notificationData: PropTypes.object.isRequired
}

export default Notification;